import { Expose } from 'class-transformer'

export class DeviceType {
  @Expose() id: number

  @Expose() displayName: string

  @Expose() lastActiveAt: string
}
